
	import Component from 'vue-class-component'
	import moduleStore from './store/videoPaySuccess';
	import Vue from 'vue';
	import PageState from './store/state';
    import { getQueryString } from "@/utils/location";

	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class videoPaySuccessPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
        orderInfo = {
            phone: '',
            desc: '',
        };
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			this.state.title="支付成功"
			this.state.self = this;
            //获取订单信息
            this.orderInfo.phone = getQueryString('phone');
            this.orderInfo.desc = getQueryString('desc');
		}
	
	}